import { render, staticRenderFns } from "./RulerList.vue?vue&type=template&id=87f49960&scoped=true"
import script from "./RulerList.vue?vue&type=script&lang=js"
export * from "./RulerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f49960",
  null
  
)

export default component.exports